export default "__VITE_ASSET__BuSobjVP__"